import React from 'react';

// Reusable animated label for buttons (arrow + clouds + dots)
export default function ButtonLoader({ labelIdle = 'RUN', compilingLabel = 'Compiling', compiling = false, className = '' }) {
  return (
    <span className={`relative inline-flex items-center gap-2 select-none ${className}`}>
      {compiling && (
        <span className={`inline-flex items-center justify-center w-5 h-5 bl-float`}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-3.5 h-3.5 text-white/70">
            <path d="M12 19V6" />
            <path d="M5 12l7-7 7 7" />
          </svg>
        </span>
      )}
      <span className="font-medium relative z-[1]">
        {compiling ? (
          <span className="bl-label-fall">{compilingLabel}</span>
        ) : (
          labelIdle
        )}
      </span>
      {compiling && (
        <span className="absolute inset-0 z-0 pointer-events-none bl-clip">
          <span className="absolute bl-clouds">
            <img src="/image.png" alt="" className="cloud-ico" />
          </span>
        </span>
      )}
      <style>{`
        @keyframes blFloat { 0% { transform: translateY(0); } 50% { transform: translateY(-4px); } 100% { transform: translateY(0); } }
        .bl-float { animation: blFloat 1.1s ease-in-out infinite; }

        /* Compiling label falls from below to center */
        .bl-label-fall {
          display: inline-block;
          opacity: 0;
          transform: translateY(40px);
          animation: blLabelFall 0.6s cubic-bezier(.6,.2,.2,1) forwards;
        }
        @keyframes blLabelFall {
          0% { opacity: 0; transform: translateY(40px); }
          60% { opacity: 1; transform: translateY(-6px); }
          100% { opacity: 1; transform: translateY(0); }
        }

        /* Clip box to keep clouds strictly inside the button label area */
        .bl-clip { overflow: hidden; border-radius: 6px; }
        /* Left-side only cloud lane spanning full label height */
        .bl-clouds { top: 0; bottom: 0; left: 0; width: 40px; }
        /* Use provided cloud image; 80% transparent (opacity 0.2 at peak) */
        .cloud-ico { position: absolute; width: 22px; height: auto; object-fit: contain; opacity: 0; top: -30%; left: 2px; filter: none; animation: blCloudFall 1100ms linear infinite; }
        @keyframes blCloudFall { 0% { top: -30%; opacity: 0; } 12% { opacity: .45; } 75% { opacity: .25; } 100% { top: 105%; opacity: 0; }
        }

        .bl-dots .dot { display:inline-block; width:2px; }
        @keyframes blDotPulse { 0% { opacity:.2 } 50% { opacity:1 } 100% { opacity:.2 } }
        .bl-dots .dot1 { animation: blDotPulse 1.2s infinite; }
        .bl-dots .dot2 { animation: blDotPulse 1.2s infinite; animation-delay: .2s; }
        .bl-dots .dot3 { animation: blDotPulse 1.2s infinite; animation-delay: .4s; }
      `}</style>
    </span>
  );
}
